import { render, staticRenderFns } from "./EditNotice.vue?vue&type=template&id=c769cd4e&scoped=true&lang=pug&"
import script from "./EditNotice.vue?vue&type=script&lang=js&"
export * from "./EditNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c769cd4e",
  null
  
)

export default component.exports